import React from "react"
import { graphql, useStaticQuery } from "gatsby";

// Internationalization
import { useTranslation } from 'react-i18next';

// Components
import NavigationLists from '../navigation-lists/navigation-lists';
import UtilsService from "../../services/utils.service";
import useMediaQuery from '../../hooks/useMediaQuery';
import InstaFeed from "../instafeed/instafeed";

// Assets
import swedenFlag from "../../images/sweden.svg";
import denmark from '../market-switcher/assets/denmark-flag.png';
import europe from '../market-switcher/assets/europe.png';
import norway from '../market-switcher/assets/norway.png';
import netherlands from '../market-switcher/assets/netherlands.png';
import unitedKingdom from '../market-switcher/assets/uk-flag.png';


// Styles
import * as footerStyles from './footer.module.scss'
import FooterTabs from "./footer-tabs";

const Footer = (props) => {

    const data = useStaticQuery(graphql`
    query {
        footerse: datoCmsFooter (locale: { eq: "sv-SE" }) {
            locale
            backgroundImage{
                fluid{
                    ...GatsbyDatoCmsFluid
                }
            }
            footerTop
            footerTopLink
            footerTopLinkText
            footerTopImage{
                fluid{
                    ...GatsbyDatoCmsFluid
                }
            }
            infoMenu{
            url
            name
            }
            flowLinks{
                url
                name
            }
            helpMenu{
            url
            name
            }
            socialMedia{
            link
            url
            icon{
                url
            }
            name
            }
            subscribe
          osLogo{
              fixed(width: 72) {
                ...GatsbyDatoCmsFixed
              }
            }
            logos{
            url
            }
        }
        footerdk: datoCmsFooter (locale: { eq: "da" }) {
            locale
            backgroundImage{
                fluid{
                    ...GatsbyDatoCmsFluid
                }
            }
            footerTop
            footerTopLink
            footerTopLinkText
            footerTopImage{
                fluid{
                    ...GatsbyDatoCmsFluid
                }
            }
            infoMenu{
            url
            name
            }
            flowLinks{
                url
                name
            }
            helpMenu{
            url
            name
            }
            socialMedia{
            link
            url
            icon{
                url
            }
            name
            }
            subscribe
            osLogo{
              fixed(width: 72) {
                ...GatsbyDatoCmsFixed
              }
            }
            logos{
            url
            }
        }
        footereu: datoCmsFooter (locale: { eq: "en" }) {
            locale
            backgroundImage{
                fluid{
                    ...GatsbyDatoCmsFluid
                }
            }
            footerTop
            footerTopLink
            footerTopLinkText
            footerTopImage{
                fluid{
                    ...GatsbyDatoCmsFluid
                }
            }
            infoMenu{
            url
            name
            }
            flowLinks{
                url
                name
            }
            helpMenu{
            url
            name
            }
            socialMedia{
            link
            url
            icon{
                url
            }
            name
            }
            subscribe
            osLogo{
              fixed(width: 72) {
                ...GatsbyDatoCmsFixed
              }
            }
            logos{
            url
            }
        }
        footernl: datoCmsFooter (locale: { eq: "nl" }) {
            locale
            backgroundImage{
                fluid{
                    ...GatsbyDatoCmsFluid
                }
            }
            footerTop
            footerTopLink
            footerTopLinkText
            footerTopImage{
                fluid{
                    ...GatsbyDatoCmsFluid
                }
            }
            infoMenu{
            url
            name
            }
            flowLinks{
                url
                name
            }
            helpMenu{
            url
            name
            }
            socialMedia{
            link
            url
            icon{
                url
            }
            name
            }
            subscribe
            osLogo{
              fixed(width: 72) {
                ...GatsbyDatoCmsFixed
              }
            }
            logos{
            url
            }
        }
        footerno: datoCmsFooter (locale: { eq: "no" }) {
            locale
            backgroundImage{
                fluid{
                    ...GatsbyDatoCmsFluid
                }
            }
            footerTop
            footerTopLink
            footerTopLinkText
            footerTopImage{
                fluid{
                    ...GatsbyDatoCmsFluid
                }
            }
            infoMenu{
            url
            name
            }
            flowLinks{
                url
                name
            }
            helpMenu{
            url
            name
            }
            socialMedia{
            link
            url
            icon{
                url
            }
            name
            }
            subscribe
            osLogo{
              fixed(width: 72) {
                ...GatsbyDatoCmsFixed
              }
            }
            logos{
            url
            }
        }
        datoCmsHeader{
            darkLogo{
                url
                fixed( height: 182){
                    ...GatsbyDatoCmsFixed
                }
              }
              whiteLogo{
                url
                fixed( height: 182){
                    ...GatsbyDatoCmsFixed
                }
              }       
        }
    }
`)

    // Translation Function
    const { t } = useTranslation();

    const headerData = data.datoCmsHeader;
    const footerData = data['footer' + props.country];

    //TODO : Maybe change to get country from Layout to prevent wrong URL form build
    const locale = UtilsService.getLocaleFromUrl();

    const isTabletOrMobile = useMediaQuery(900);

    const flags = {
        se: swedenFlag,
        dk: denmark,
        eu: europe,
        no: norway,
        nl: netherlands,
        uk: unitedKingdom
    }
    return (
        <div className={
            ` ${props.isHome === true ? `cd-bf-mode` : ''}  
            `
        }>
              <InstaFeed />
            { footerData ?
            <footer className={`${footerStyles.cdFooter} cd-footer`}>
                <div className={footerStyles.cdFooterMiddle}>
                    <div className="cd-max-width cd-large-width">
                        <div className={footerStyles.cdFooterMiddleContent}>
                            <div className={`${footerStyles.cdFooterMiddleItem} ${footerStyles.cdFooterSubscribe}`}>
                                {/* <h4>{t('footer.column1.title')}</h4>
                                <Subscribe
                                    description={footerData.subscribe}
                                    label={`${t('widgets.subscribe.label')}`}
                                    isWhite={true}
                                /> */}
                            </div>
                            {!isTabletOrMobile ?
                                <>
                                <div className={footerStyles.cdFooterMiddleItem}>
                                        <h4>Flowlife</h4>
                                        <NavigationLists data={footerData.flowLinks} />
                                    </div>
                                    <div className={footerStyles.cdFooterMiddleItem}>
                                        <h4>{t('footer.follow')}</h4>
                                        <NavigationLists data={footerData.socialMedia} />
                                    </div>
                                    <div className={footerStyles.cdFooterMiddleItem}>
                                        <h4>{t('footer.service')}</h4>
                                        <NavigationLists data={footerData.helpMenu} />
                                    </div>
                                    <div className={footerStyles.cdFooterMiddleItem}>
                                        <h4>{t('footer.info')}</h4>
                                        <NavigationLists data={footerData.infoMenu} />
                                    </div>
                                </>   
                                :
                                <FooterTabs
                                    flowLinks={footerData.flowLinks}
                                    socialMedia={footerData.socialMedia}
                                    helpMenu={footerData.helpMenu}
                                    infoMenu={footerData.infoMenu}
                                />
                                }
                        </div>
                    </div>
                </div>
                {!isTabletOrMobile ?
                <div className={footerStyles.cdFooterMarketSwitcher}>
                    <div className="cd-max-width cd-large-width">
                        <button onClick={props.flyinToggle} className={""}>
                            <img src={flags[props.country]} alt="Flag" />
                            <span>{t('langSwitch.' + locale.country)}</span>
                        </button>
                    </div>
                </div>
                : ''
                }
                <div className={footerStyles.cdFooterBottom}>
                    <div className="cd-max-width">
                        <div className={footerStyles.cdFooterBottomContent}>
                             <div className={`${footerStyles.cdFooterDarkLogo} cd-footer-dark-logo`}>
                                <img alt="LOGO" src={headerData.darkLogo.url} /> 
                             </div>
                             <div className={`${footerStyles.cdFooterWhiteLogo} cd-footer-white-logo`}>
                                <img alt="LOGO" src={headerData.whiteLogo.url} />
                             </div>
                        </div>
                    </div>
                </div>

                {isTabletOrMobile ?
                <div className={footerStyles.cdFooterMobileBottom}>
                    <div className="cd-max-width">
                        <div className={footerStyles.cdFooterMobileBottomItem}>
                            <p>Change location:</p>
                            <button onClick={props.flyinToggle} className={""}>
                                <img src={flags[props.country]} alt="Flag" />
                                <span>{t('langSwitch.' + locale.country)}</span>
                            </button>
                        </div>
                        <div className={footerStyles.cdFooterMobileBottomCopyright}>
                            <span>Flowlife © 2023 All rights reserved</span>
                        </div>
                    </div>
                </div>       
                :
                ''
                }
                <script src="https://chimpstatic.com/mcjs-connected/js/users/301149ad6e31af6c7985e651a/dc12e5b23f03be7e9307df5f1.js" async></script>
            </footer> : ''
            }
        </div>
    )
}

export default Footer
